import React, { Component } from "react";
import {  Feed, List, Button, Icon,} from 'semantic-ui-react'
import { invokeApig, downloadS3Text, downloadS3 } from "../libs/awsLib";
import { formatDateTime, formatXml } from "../libs/sharedFunctions";
import LoadingPage from "./LoadingPage"
import ErrorPage from "./ErrorPage"  
import _ from 'lodash';

export default class SmartHealthChecks extends Component {
  constructor(props) {
    super(props);
    this.state={healthChecks: [], isLoading: true, logFilter: ""};

  }

  loadHealthChecks(smartdeviceid) {
    
    //get view data    
    invokeApig({path: '/api/smartdevices/' +smartdeviceid+'/smarthealthchecks' , method: "GET"}).then((result)=>{
      
      if(result.status===200) 
      {
        this.setState({isLoading: false, healthChecks: _.sortBy(result.data, ['id'], ['desc']), loadError: false})
      }  
      else if (result.status===404)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Page not found', loadErrorDetail: 'The page you requested was not found'})
      }
      else if (result.status===400)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Error loading page', loadErrorDetail: result.data})
      }    
      else if (result.status===401)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Permission denied', loadErrorDetail: 'You are not authorised to view this page'})
      }     
      else if (result.status===502)
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'API Error', loadErrorDetail: 'The API returned an error'})
      }          
      else 
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'Unexpected return code' + result.status, loadErrorDetail: result.data})
      }        
      
    }).catch(e=>
      {
        this.setState({isLoading: false, loadError: true, loadErrorHeader: 'An error occurred submitting the request', loadErrorDetail: []})
      })
    
  }

  healthCheckGatherData=(smartdeviceid)=>{
    invokeApig({path: "/smart/smartdevices/"+smartdeviceid+"/functions/smarthealthcheckgatherdata", method: "POST", body: {}})
    alert("Request submitted")
  }

  healthCheckValidate=(smartdeviceid)=>{
    invokeApig({path: "/smart/smartdevices/"+smartdeviceid+"/functions/smarthealthcheckvalidate", method: "POST", body: {}})
    alert("Request submitted")
  }

  healthCheckResolve=(smartdeviceid)=>{
    invokeApig({path: "/smart/smartdevices/"+smartdeviceid+"/functions/smarthealthcheckresolve", method: "POST", body: {}})
    alert("Request submitted")
  }

  componentDidMount ()
  {
    this.loadHealthChecks(this.props.smartdeviceid)
  }

  componentWillReceiveProps(newProps)
  {
    if (newProps.smartdeviceid != this.props.smartdeviceid)
    {
      this.loadHealthChecks(newProps.smartdeviceid)
    }
  }
 
  

  render() {
    const categoryDesciptions = {
      "schedule": "Schedule", "paymentmode": "Payment Mode", "primarytariff": "Tariff", "billingcalendar": "Billing Calendar", "suppliercertificates": "Supplier Certificates", "dnocertificates": "DNO Certificates", "devicecertificates": "Device Certificates", "loadlimitsetttings": "Load Limits", "instantaneouspowerthresholds": "Power Thresholds", "eventandalertbehaviours": "Alert Configuration", "devicewhitelist": "Device White List"
    }

    if (this.state.isLoading) 
    return (
    <LoadingPage />
    )
    else if (this.state.loadError)
    return (
      <ErrorPage visible={true} messageHeader={this.state.loadErrorHeader} messageDetail={this.state.loadErrorDetail}/>
    )
    else
    return (
    <div>
    <Button className="seaglassbutton" onClick={()=>{this.setState({isLoading: true});this.healthCheckGatherData(this.props.smartdeviceid);}}><Icon name='spy'/>Gather Data</Button>
    <Button className="seaglassbutton" onClick={()=>{this.setState({isLoading: true});this.healthCheckValidate(this.props.smartdeviceid);}}><Icon name='search'/>Validate</Button>
    <Button className="seaglassbutton" onClick={()=>{this.setState({isLoading: true});this.healthCheckResolve(this.props.smartdeviceid);}}><Icon name='wrench'/>Resolve Issues</Button>
    <Button className="seaglassbutton" onClick={()=>{this.setState({isLoading: true});this.loadHealthChecks(this.props.smartdeviceid);}}><Icon name='refresh'/>Refresh</Button>

    <Feed className="devicedetail">
    
    {this.state.healthChecks.reverse().map(healthCheck=>{
        return <Feed.Event>
        <Feed.Label icon={(healthCheck.healthcheckstatus===1 ? "check" : "warning")} />
        <Feed.Content>
        <Feed.Summary style={{color: this.props.darkmode ? "white": "black"}}>Health check run on {formatDateTime(new Date(healthCheck.datetime))}</Feed.Summary>
        <List>
          {Object.keys(healthCheck.data).map(key=>{
            return <List.Item style={{color: healthCheck.data[key]==="OK" ? "black": "red"}}><List.Icon name={healthCheck.data[key]==="OK" ? "check": "warning"}/>{categoryDesciptions[key]} - {healthCheck.data[key]}</List.Item>
          })}
        </List>
        </Feed.Content>
        </Feed.Event>
    })}
    </Feed>
    </div>  
    )
  }
}